import { useEffect, useState } from "react";

import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";

import { useEventBus } from "hooks/useEventBus";
import { fetchEsgDownloadsAuthorization } from "services/apiClient/esgApiClient";

export const useEsgAuthorization = () => {
  const [hasEsgDocumentsContent, setHasEsgDocumentsContent] =
    useState<boolean>(false);
  const [authenticated] = useEventBus(EventBusTopic.IsAuthenticated);

  useEffect(() => {
    if (authenticated) {
      fetchEsgDownloadsAuthorization().then((esgAuthResponse) => {
        if (esgAuthResponse) {
          setHasEsgDocumentsContent(
            esgAuthResponse?.hasDocumentsContent || false
          );
        }
      });
    }
  }, [authenticated]);

  return { hasEsgDocumentsContent };
};
